module.exports = __webpack_public_path__ + "media/images/admin/icons/hard-drive-7cda33f002565ada0541e0abbe87fa03.svg";